import { render, staticRenderFns } from "./scene-invoke.vue?vue&type=template&id=3c53472e&scoped=true&"
import script from "./scene-invoke.vue?vue&type=script&lang=js&"
export * from "./scene-invoke.vue?vue&type=script&lang=js&"
import style0 from "./scene-invoke.vue?vue&type=style&index=0&id=3c53472e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c53472e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/fcs/fcs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c53472e')) {
      api.createRecord('3c53472e', component.options)
    } else {
      api.reload('3c53472e', component.options)
    }
    module.hot.accept("./scene-invoke.vue?vue&type=template&id=3c53472e&scoped=true&", function () {
      api.rerender('3c53472e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/scene-invoke.vue"
export default component.exports